import { Body, Box } from '@hover/blueprint';
import React from 'react';
import { animated, useTrail } from 'react-spring';

import { animationConfig } from 'src/modules/designStudio/helpers/animationConfig';

import { ImageSelectionButton } from '../../ImageSelectionButton';
import { CountItemsHeader } from '../CountItemsHeader';
import { List } from '../List';

type Item = {
  id: string;
  name?: string;
  thumbnail: string;
};

interface ThumbnailListProps {
  title: string;
  items: Item[];
  selectedId?: string;
  onClick: (id: string) => void;
  subHeader?: React.ReactNode;
}

const ThumbnailList = ({
  onClick,
  selectedId,
  title,
  items,
  subHeader,
}: ThumbnailListProps) => {
  const trails = useTrail(items.length, animationConfig.menuItemAnimation);
  const headerBar = <CountItemsHeader category={title} count={trails.length} />;

  return (
    <List header={headerBar} subHeader={subHeader}>
      {trails.map((style, index) => {
        const { id, name, thumbnail } = items[index];
        return (
          <animated.div key={id} style={style}>
            <Box
              display="grid"
              justifyItems="center"
              key={id}
              marginBottom={!name ? 100 : undefined}
              marginTop={100}
              marginX={100}
              minWidth="60px"
            >
              <Box>
                <ImageSelectionButton
                  alt={name || id}
                  fill="minimal"
                  height="72px"
                  isSelected={selectedId === id}
                  label={id}
                  onClick={() => onClick(id)}
                  shape="circle"
                  src={thumbnail}
                  width="72px"
                />
              </Box>
              {name && (
                <Body
                  color={selectedId === id ? 'neutral.700' : 'neutral.600'}
                  marginBottom={100}
                  marginTop={200}
                  size={300}
                >
                  {name}
                </Body>
              )}
            </Box>
          </animated.div>
        );
      })}
    </List>
  );
};

export { ThumbnailList };
